import { Button } from '@material-ui/core';
import axios from 'axios';
import React from 'react';
import { RiFileSettingsFill } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import useUsers from '../../hooks/useUsers';
import Navbar from '../Shared/Navbar';

const AdminRole = () => {

    const [users] = useUsers();

    const handleUpdateUser = async (updatedUser) => {
        await axios.put("https://tripaide-server.onrender.com/users", updatedUser)
            .then(res => {
                //console.log(res.data);
                if (res.data.acknowledged) {
                    toast.success("Profile is updated.");
                    window.location.reload();
                } else {
                    toast.error("Something went wrong.");
                }
            });
    };

    const handleUpdateProfile = (e) => {
        e.preventDefault();
        //console.log(users?.find(u => u?.id === e.target.id.value));
        const updatedData = {
            email: e.target.email.value,
            role: e.target.role.value,
        };

        console.log(updatedData);

        handleUpdateUser(updatedData);
        //toast.error("User doesn't exists!!");
    }

    return (
        <div>
            <Navbar />
            <div className='w-4/5 mx-auto my-16'>
                <Link to='/dashboard' className="inline-block px-3 py-2 mr-4 mt-4 mb-16 rounded bg-pink-600 font-bold text-white">
                    <span className='flex items-center'>
                        <RiFileSettingsFill className='text-lg mr-2' />
                        <span>Manage Posts</span>
                    </span>
                </Link>

                <form onSubmit={handleUpdateProfile} className='w-11/12 lg:w-2/3 p-12 shadow-custom-lg rounded-2xl '>
                    <h1 className='text-pink-600 text-2xl font-bold mb-4'>Set User Role</h1>
                    <div required className='mb-8'>
                        <h2 className='text-lg text-gray-500 font-bold'>Enter Email Address</h2>
                        <input required className='border-2 rounded-lg px-4 py-2 my-2 block w-2/3' type="email" name="email" id="email" placeholder='Email Address' />
                    </div>
                    <div className='mb-8'>
                        <h2 className='text-lg text-gray-500 font-bold'>Add User As a - </h2>
                        <select id="role" name="role" required className='w-2/3 border-2 rounded-lg px-4 py-1'>
                            <option value="guide">Guide</option>
                            <option value="admin">Admin</option>
                            <option value="user">User</option>
                            <option value="blocked">Blocked</option>
                        </select>
                    </div>
                    <Button type='submit' className='bg-yellow-500 text-lg font-medium' variant="contained">Update</Button>
                </form>
            </div>
        </div>
    );
};

export default AdminRole;